export const keywordModalTexts = {
    advancedButtonText: "activation.topics.advance.modal.button.text",
    oneKeywordSelected: "activation.topics.advance.modal.keyword.selected",
    multiKeywordSelected: "activation.topics.advance.modal.multi.keywords.selected",
    oneKeywordDeleted: "activation.topics.advance.modal.keyword.deleted",
    multiKeywordDeleted: "activation.topics.advance.modal.multi.keywords.deleted",
    nameYourTopic: "activation.topics.advance.modal.name.topic",
    deleteButton: "common.delete",
    clearSelection: "activation.topics.advance.modal.clear.selection",
    keywordInputPlaceholder: "activation.topics.advance.modal.input.placeholder",
    subtitle: "activation.topics.advance.modal.subtitle",
    selectExistingKW: "activation.topics.advance.modal.select.existing",
    clickToAdd: "activation.topics.advance.modal.click.to.add",
    alreadyIncluded: "activation.topics.advance.modal.already.included",
    alreadyIncludedCount: "activation.topics.advance.modal.already.included.count",
    matchingKWTitle: "activation.topics.advance.modal.matching.keywords",
    maxKeywords: "activation.topics.advance.modal.max.keywords.count",
    searchPlaceholder: "activation.topics.advance.modal.search.placeholder",
    undo: "activation.topics.advance.modal.undo",
    limitation: "activation.topics.advance.modal.limitation.toast.text",
    createButtonTooltip: "activation.topics.advance.modal.button.tooltip",
    errorLimitText: "activation.topics.advance.modal.error.limit.text",
    clickToClearInput: "activation.topics.advance.modal.click.to.clear",
    importCSV: "activation.topics.advance.modal.import.csv.button",
    importCSVTooltip: "activation.topics.advance.modal.import.csv.tooltip",
    importCSVloading: "activation.topics.advance.modal.import.csv.loading",
    dropdownSeparatorMyListText: "activation.topics.advance.modal.separator.my.list",
    dropdownSeparatorSharedListText: "activation.topics.advance.modal.separator.shared.list"
};
